import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { dropdown } from "MODULES/shared/decorators";

export function DropDown({
  icon,
  menuClass,
  visible,
  toggle,
  children,
  buttonClasses = "btn-link",
  dropdownStyles = {},
  containerClasses = {},
  iconStyles = {}
}) {
  const classes = classNames(
    "dropdown control-dropdown",
    { open: visible },
    containerClasses
  );

  return (
    <div className={classes} style={dropdownStyles}>
      <button className={buttonClasses} onClick={toggle}>
        <i className={icon} style={iconStyles} />
      </button>
      <ul className={`dropdown-menu ${menuClass}`}>{children}</ul>
    </div>
  );
}

DropDown.propTypes = {
  visible: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  menuClass: PropTypes.string,
  icon: PropTypes.string.isRequired,
  iconStyles: PropTypes.shape({}),
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]),
  containerClasses: PropTypes.shape({}),
  dropdownStyles: PropTypes.shape({}),
  buttonClasses: PropTypes.string
};

export default dropdown(DropDown);



// WEBPACK FOOTER //
// ./app/modules/shared/components/DropDown/DropDown.jsx